import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from 'utils/routeHelper';
import { VERSION_NUMBER, BUILD_NUMBER } from 'utils/constants';
import './styles.scss';

const Footer = () => (
  <footer>
    <div styleName="wrapper" data-testid="footer">
      <div styleName="inside-wrapper">
        <ul styleName="links">
          <li styleName="link-item">
            <a
              href={routes.TERMS_OF_SERVICE}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          </li>
          <li styleName="link-item">
            <a
              href={routes.PRIVACY_POLICY}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </li>
          <li styleName="link-item">
            <Link
              to={routes.SUPPORT}
              title="Support"
              target="_blank"
              rel="noopener noreferrer"
            >
              Support
            </Link>
          </li>
        </ul>
        <div styleName="copyright">
          <span styleName="copyright-item">© 2022 Pear Therapeutics</span>
          <span styleName="copyright-item">{`Version: ${VERSION_NUMBER} (${BUILD_NUMBER})`}</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
